import Route from '@ember/routing/route';
import { service } from '@ember/service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import Store from '@ember-data/store';
import NewsletterAccountModel from 'donor-elf-web/models/newsletter-account';
import AbilitiesService from 'donor-elf-web/services/abilities';
import { action } from '@ember/object';

export interface NewsletterRouteModel {
  newsletterAccount?: NewsletterAccountModel;
}

export default class NewsletterRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;

  beforeModel(transition: any) {
    if (this.abilities.noAbility('edit_contact')) {
      transition.abort();
      return;
    }
    this.navbarSettings.title = 'Newsletter Sync';
  }

  async model(): Promise<NewsletterRouteModel> {
    let newsletterAccount = (
      await this.store.query('newsletter-account', {})
    ).slice()[0];
    return {
      newsletterAccount,
    };
  }

  @action
  refreshNewsletterRoute() {
    this.refresh();
  }
}
